// extracted by mini-css-extract-plugin
module.exports = {"bottomNav":"App_bottomNav__3aU7p"};